import { useMemo } from 'react'
import type { Division } from '@/lib'
import { getDivisionBadge } from '../-components/DivisionBadge'
import { useDivisions } from './useDivisions'

/** 3段階ソート: 0=通常 > 1=アサイン不可 > 2=旧部署 */
function getDivisionCategory(d: Division): number {
  if (!d.enabled) return 2
  if (!d.is_assignable) return 1
  return 0
}

function toDivisionOptions(divisions: Division[]) {
  return [...divisions]
    .sort((a, b) => getDivisionCategory(a) - getDivisionCategory(b))
    .map((d) => ({
      value: String(d.id),
      label: d.short_name ?? d.name,
      leftItem: getDivisionBadge(d),
    }))
}

/**
 * 部署一覧を取得し、旧部署バッジ・ソート済みのセレクト用オプションも返すフック
 */
export function useDivisionOptions(filters?: { isEnabled?: boolean; isAssignable?: boolean }) {
  const query = useDivisions(filters)
  const divisions = query.data?.divisions ?? []
  const divisionOptions = useMemo(() => toDivisionOptions(divisions), [divisions])

  return { ...query, divisions, divisionOptions }
}
